import { render, staticRenderFns } from "./IdtelForm.vue?vue&type=template&id=04b25402"
import script from "./IdtelForm.vue?vue&type=script&lang=js"
export * from "./IdtelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports